<template>
  <v-col style="max-width: 900px">
    <h1 class="primary--text mt-3">
      {{ $t('documentation.texts.automatedTasks.title') }}
    </h1>
    <h2 class="primary--text mt-3">
      {{ $t('documentation.texts.automatedTasks.clonation.title') }}
    </h2>
    <p>
      {{ $t('documentation.texts.automatedTasks.clonation.p1') }}
    </p>
    <v-img
      style="
        width: 100%;
        max-width: 800px;
        align-self: center;
        border-radius: 10px;
      "
      contain
      class="mb-5"
      :src="pic1Name"
    />
    <p>
      {{ $t('documentation.texts.automatedTasks.clonation.p2') }}
    </p>
    <div class="mb-10" />
  </v-col>
</template>

<script>
export default {
  computed: {
    pic1Name() {
      return require('@/assets/documentation/automatedTasks/' +
        this.$t('documentation.texts.automatedTasks.clonation.pic1') +
        '.png')
    },
  },
  methods: {
    goDoc(section, subsection = '') {
      if (subsection === '')
        this.$router.push({
          name: 'DocumentationView',
          query: { section: section },
        })
      else
        this.$router.push({
          name: 'DocumentationView',
          query: { section: section, subsection },
        })
    },
  },
}
</script>

<style>
.custom-link {
  transition: 0.3s;
  cursor: pointer;
}
.custom-link:hover {
  text-decoration: underline;
}
</style>
